import { OrganizationSwitcher } from "@components/navigation/OrganizationSwitcher";
import { FC } from "react";
import { Menu } from "@design-system/Menu/Menu.lib";
import { SettingsDropdownItem } from "@components/mainInterface/UserDropdown/SettingsDropdownItem";
import { OrganizationSettingsPages } from "@components/settings/constants";
import { useCanPerformOrganizationAction } from "@hooks/permissions/organization/useCanPerformOrganizationAction";
import { OrganizationAction } from "@common/userOrganizationRoles";

/** The org menu's items: the organization switcher and the firm settings. */
export const OrganizationViewNavigationDropdownBody: FC = () => {
    const canManageOrganizationSettings = useCanPerformOrganizationAction(
        OrganizationAction.MANAGE_ORGANIZATION_SETTINGS,
    );

    return (
        <>
            <OrganizationSwitcher />

            {canManageOrganizationSettings && (
                <>
                    <Menu.Separator />
                    <Menu.Group>
                        <Menu.GroupLabel>Firm</Menu.GroupLabel>
                        <SettingsDropdownItem
                            path={OrganizationSettingsPages.FIRM_INFORMATION}
                        >
                            Profile
                        </SettingsDropdownItem>
                        <SettingsDropdownItem
                            path={OrganizationSettingsPages.TASK_GROUPS}
                        >
                            Task groups
                        </SettingsDropdownItem>
                    </Menu.Group>
                </>
            )}
        </>
    );
};
